/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AppServices_UserAccount_PasswordLessLoginTokenGeneratedResponse } from '../models/Wealthlane_AppServices_UserAccount_PasswordLessLoginTokenGeneratedResponse';
import type { Wealthlane_AppServices_UserAccount_PasswordLessTokenGenerationRequest } from '../models/Wealthlane_AppServices_UserAccount_PasswordLessTokenGenerationRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserPasswordLessLoginGenerateService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AppServices_UserAccount_PasswordLessLoginTokenGeneratedResponse OK
     * @throws ApiError
     */
    public static postApiIdentityUserAccountPassworlessGenerate(
requestBody?: Wealthlane_AppServices_UserAccount_PasswordLessTokenGenerationRequest,
): CancelablePromise<Wealthlane_AppServices_UserAccount_PasswordLessLoginTokenGeneratedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/user-account/passworless/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
